module.exports = __webpack_public_path__ + "img/制御工学3_6_2.78d884de.png";